import { REACT_APP_STORAGE_URL } from "shared/config";
import Icon, { IconTypes } from "shared/ui/icon";
import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";
import { twMerge } from "tailwind-merge";

const LINK = "#visualizer";
const PHONE_IMAGE_URL = `${REACT_APP_STORAGE_URL}/assets/images-v2/sample-phone.png`;

interface Props {
  isVisible: boolean;
  className?: string;
}

//Function to open the visualizer
const openVisualizer = () => {
  //@ts-ignore
  if (typeof window.wizartOpen === "function") {
    //@ts-ignore
    window.gtmPush("panel_wizart_click");
    //@ts-ignore
    window.wizartOpen();
  }
};

const SampleImageFooter = ({ className, isVisible }: Props) => {
  if (!isVisible) return <></>;
  return (
    <div
      className={twMerge(
        "gg-relative gg-w-full gg-rounded-sm gg-py-4 sm:gg-pb-0 lg:gg-bg-grey-500",
        className,
      )}
    >
      <img
        src={PHONE_IMAGE_URL}
        height={155}
        alt="sample phone"
        className="gg-absolute gg-bottom-0 gg-left-0 lg:gg-hidden xl:gg-block"
      />

      <div className="gg-pl-32 lg:gg-pl-5 xl:gg-pl-32 2xl:gg-pl-32">
        <Heading
          headingLevel="h4"
          className="gg-mb-3 gg-text-sm sm:gg-mb-1 sm:gg-text-lg"
        >
          Bekijk hoe het akoestisch paneel op jouw muur staat
        </Heading>
        <div className="gg-flex gg-items-end gg-justify-between">
          <Text className="gg-hidden gg-pb-7 gg-text-sm sm:gg-block">
            Maak een foto, kies jouw favoriete paneel en bekijk het resultaat!
          </Text>
          <button
            onClick={openVisualizer}
            className="gg-group gg-flex gg-shrink-0 gg-items-center gg-gap-x-2 gg-rounded-sm gg-bg-dark-blue gg-px-3.5 gg-py-3 gg-text-sm gg-font-bold gg-text-white hover:gg-bg-dark-blue/90"
          >
            Start de vizualizer{" "}
            <Icon
              className="gg-transition gg-duration-500 gg-ease-in-out group-hover:gg-translate-x-1.5"
              name={IconTypes.ARROW_WHITE}
            />
          </button>
        </div>
      </div>
    </div>
  );
};
export default SampleImageFooter;
